"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsStateAttributesMapping = void 0;
var _TabsRootDataAttributes = require("./TabsRootDataAttributes");
const tabsStateAttributesMapping = exports.tabsStateAttributesMapping = {
  tabActivationDirection: dir => ({
    [_TabsRootDataAttributes.TabsRootDataAttributes.activationDirection]: dir
  })
};